'use client'
import React, { useEffect } from 'react'

function AdSterra320x50() {
  useEffect(() => {
      (window as any).atOptions = {
          'key' : '9b0e8b89cdbf657cd304fe337dcdb60f',
          'format' : 'iframe',
          'height' : 50,
          'width' : 320,
          'params' : {}
        };
      // Dynamically build and append the script block to bypass Next.js timing issues
      const container = document.getElementById('adsterra-container');
      if (container && container.childElementCount === 0) {
        const script = document.createElement('script');
        script.src = 'https://www.highperformanceformat.com/9b0e8b89cdbf657cd304fe337dcdb60f/invoke.js';
        script.async = true;
        container.appendChild(script);
      }
    }, []);
  
    return (
      <div className='w-full flex justify-center items-center'>
        <div id="adsterra-container" style={{ width: '320', height: '50px' }}></div>
      </div>
  
    )
}

export default AdSterra320x50